
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid } from "@mui/material";
export const TableA = ({ leq1, leq5, leq12, doseAndMaxList, date, isSundayOrPH }) => {

  // Manual parse to ensure NO timezone shifts from the browser
  const dateParts = date.split('-');
  const formattedToday = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;

  const currentDateObj = new Date(date + 'T00:00:00+08:00');
  const tomorrowObj = new Date(currentDateObj);
  tomorrowObj.setDate(currentDateObj.getDate() + 1);
  const formattedTomorrow = tomorrowObj.toLocaleDateString("en-GB");

  const generateTime = (index) => {
    if (index >= 0 && index <= 16) {
      return { time: `${index + 7}`, rowSpan: 17, date: '-' };
    } else {
      const hour = index - 17;
      return { time: `${hour}`, rowSpan: 7, date: '-' };
    }
  };

  const baseFontSize = 13; // Define your base font size (in pixels)
  const minHeight = 650;   // The minimum window height to base the calculation on

  // Get the current window height
  const windowHeight = window.innerHeight;

  // Calculate the adjusted font size based on the window height
  const adjustedFontSize = baseFontSize * (windowHeight / minHeight);

  const adjustTime = (datetime) => {
    const currentDateTime = datetime;

    const hours = currentDateTime.getHours();

    // Handle time rounding and setting to 7AM for time period (7am - 7pm)
    if (hours >= 7 && hours < 19) {
      const startOf7AM = new Date(currentDateTime);
      startOf7AM.setHours(7, 0, 0, 0);
      return startOf7AM;
    }

    if (hours >= 0 && hours < 7) {
      // Handle time rounding and setting to 7AM for time period (12am - 7am)
      const prevDay = new Date(currentDateTime);
      prevDay.setDate(currentDateTime.getDate() - 1);
      prevDay.setHours(19, 0, 0, 0);
      return prevDay;
    } else {
      // Handle time rounding and setting to 7AM for time period (7pm - 12am)
      return new Date(currentDateTime).setHours(19, 0, 0, 0);
    }
  };

  const isEOD = (referenceTime, dataTime) => {
    const timeToNearestPeriod = adjustTime(referenceTime);
    return timeToNearestPeriod > new Date(dataTime);
  };

  // Check if an hour index falls in the 7pm-7am period (evening/night)
  // index 0-11 = 7am-6pm (daytime, first 12h period)
  // index 12-23 = 7pm-6am (nighttime, second 12h period)
  const isNighttimePeriod = (index) => index >= 12;

  //Generate output for the noise dosage column
  const getDoseAndMax5ContentForTableA = (index, doseAndMaxList, leq1, isNoiseDose) => {
    // First data and non "B - Residential" noise dose and LEQ 5 max is always 12h
    // 7pm data is at index 12. Table A only need indexes 0 and 12
    if (index !== 0 && index !== 12) {
      return ""
    }



    let displayValue = "N.A.";
    if (doseAndMaxList[index]) {
      const data = doseAndMaxList[index];
      const value = isNoiseDose ? data.noise_dose_percentage : data.leq5_max;
      const roundingDP = isNoiseDose ? 2 : 1;
      const recordDate = new Date(date + 'T00:00:00+08:00');
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      const isPastDate = recordDate.getTime() < today.getTime();

      if (isPastDate && !isNoiseDose) {
        displayValue = "EOD";
      } else if (isEOD(new Date(date), data.timestamp)) {
        displayValue = "-";
      } else {
        displayValue = value === null
          ? "N.A."
          : (value === "-1.00" && !isNoiseDose) || (isNoiseDose && value === "101.00")
            ? "OL"
            : `${parseFloat(value).toFixed(roundingDP)}${isNoiseDose ? "%" : " dBA"}`;
      }

      //Handle cases where there is data mismatch (both periods are 12h in Category A/C)
      if (data.type_of_leq !== "12h") {
        displayValue = "N.A.";
      }
    }
    return <td rowSpan={12}><br /><br />{displayValue}</td>;
  };
  const buildMaps = (leq5Array, leq1Array) => {
    const leq5Map = {};
    const leq1Map = {};
    leq5Array.forEach(it => { leq5Map[new Date(it.timestamp).toISOString()] = it; });
    leq1Array.forEach(it => { leq1Map[new Date(it.timestamp).toISOString()] = it; });
    return { leq5Map, leq1Map };
  }

  const sgtToUtcIso = (dateKey, hour, minute) => {
    const parts = dateKey.split('-').map(x => parseInt(x, 10));
    let y = parts[0], m = parts[1] - 1, d = parts[2];

    // The 0:00 to 6:59 rows represent the NEXT calendar day in this noise day's table
    if (hour < 7) {
      d += 1;
    }

    const sgtMs = Date.UTC(y, m, d, hour, minute, 0);
    const utcMs = sgtMs - (8 * 3600 * 1000);
    return new Date(utcMs).toISOString();
  }

  const { leq5Map, leq1Map } = buildMaps(leq5, leq1);

  return (
    <div style={{ marginBottom: "10px", minWidth: "100%", maxWidth: "100%" }}>
      <Grid container spacing={3} style={{ minWidth: "100%", maxWidth: "100%" }}>
        <Grid item xs={12} style={{ minWidth: "100%", maxWidth: "100%" }}>
          <Accordion defaultExpanded={true} style={{ backgroundColor: "#64748B", minWidth: "100%", maxWidth: "100%" }}>
            <AccordionSummary style={{ minWidth: "100%", maxWidth: "100%" }}
              expandIcon={< ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography color="white">{formattedToday}{isSundayOrPH ? " (Sunday / PH)" : ""}</Typography>
            </AccordionSummary>
            <AccordionDetails style={{ minWidth: "100%", maxWidth: "100%" }}>
              <Typography style={{ minWidth: "100%", maxWidth: "100%" }}>
                <table className="excel-table" style={{ backgroundColor: "white", fontSize: `${adjustedFontSize}px`, minWidth: "100%", maxWidth: "100%" }}>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Time (hr/5min)</th>
                      <th>00</th>
                      <th>05</th>
                      <th>10</th>
                      <th>15</th>
                      <th>20</th>
                      <th>25</th>
                      <th>30</th>
                      <th>35</th>
                      <th>40</th>
                      <th>45</th>
                      <th>50</th>
                      <th>55</th>
                      <th>Leq1hr/Accum</th>
                      <th>Leq12hr/Accum</th>
                      <th>Current Dose %</th>
                      <th>Max. Allow / Leq5min</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...Array(24)].map((_, index) => {
                      const { time, rowSpan } = generateTime(index);
                      return (
                        <tr>
                          {index === 0 ? <td rowSpan={rowSpan}>{formattedToday}</td> : index === 17 ? <td rowSpan={rowSpan}>{formattedTomorrow}</td> : ""}
                          <td>{time}:00</td>
                          {(() => {
                            const mins = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
                            return mins.map(m => {
                              const utcIso = sgtToUtcIso(date, parseInt(time, 10), m);
                              const item = leq5Map[utcIso];
                              return item ? <td style={{ backgroundColor: item.has_exceeded_threshold ? 'red' : '' }} key={m}>{item.leq_value}</td> : <td key={m}>-</td>;
                            })
                          })()}
                          {/* Leq1hr/Accum column - NEA Category A/C:
                            No Leq1hr threshold exists for Cat A/C, always N.A. */}
                          {(() => {
                            return <td>N.A.</td>;
                          })()}
                          {/* Leq12hr/Accum column - NEA Category A/C:
                            All days: Both daytime and nighttime are 12h periods! */}
                          {(() => {
                            if (index === 0) {
                              return <td style={{ backgroundColor: leq12[0] && leq12[0].has_exceeded_threshold ? 'red' : '' }} rowSpan={12}><br /><br />{leq12[0] ? leq12[0].leq_value : "-"}</td>;
                            }
                            if (index === 12) {
                              return <td style={{ backgroundColor: leq12[1] && leq12[1].has_exceeded_threshold ? 'red' : '' }} rowSpan={12}><br /><br />{leq12[1] ? leq12[1].leq_value : "-"}</td>;
                            }
                            return "";
                          })()}
                          {getDoseAndMax5ContentForTableA(index, doseAndMaxList, leq1, true)}
                          {getDoseAndMax5ContentForTableA(index, doseAndMaxList, leq1, false)}
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Grid>
      </Grid>
    </div>
  )
}